module.exports = __webpack_public_path__ + "static/jak-vybrat-agenturu-9d2de06437cac2a2449831b62c971734.jpg";